import {
  PAGETEMPLATEFORM_FETCHITEM_LOAD,
  PAGETEMPLATEFORM_FETCHITEM_SUCCEED,
  PAGETEMPLATEFORM_FETCHITEM_FAIL,
  PAGETEMPLATEFORM_EDITFORM_CHANGE,
  PAGETEMPLATEFORM_ENTER_RESET,
  PAGETEMPLATEFORM_CREATEITEM_LOAD,
  PAGETEMPLATEFORM_CREATEITEM_SUCCEED,
  PAGETEMPLATEFORM_CREATEITEM_FAIL,
  PAGETEMPLATEFORM_EDITITEM_LOAD,
  PAGETEMPLATEFORM_EDITITEM_SUCCEED,
  PAGETEMPLATEFORM_EDITITEM_FAIL,
  PAGETEMPLATEFORM_DELETEITEM_LOAD,
  PAGETEMPLATEFORM_DELETEITEM_SUCCEED,
  PAGETEMPLATEFORM_DELETEITEM_FAIL,
  PAGESTEMPLATEFORM_ENTER_PREPARE_SUCCEED,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case PAGESTEMPLATEFORM_ENTER_PREPARE_SUCCEED:
      return { isTemplateReady: true, templateName: action.templateName, title: action.title }
    case PAGETEMPLATEFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case PAGETEMPLATEFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case PAGETEMPLATEFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case PAGETEMPLATEFORM_ENTER_RESET:
      return { isTemplateReady: false }
    case PAGETEMPLATEFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case PAGETEMPLATEFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case PAGETEMPLATEFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case PAGETEMPLATEFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case PAGETEMPLATEFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case PAGETEMPLATEFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case PAGETEMPLATEFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case PAGETEMPLATEFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case PAGETEMPLATEFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case PAGETEMPLATEFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
